var map = {
	"./1-woha.jpeg": "5aa4",
	"./10-second.webp": "c782",
	"./2-aleph.png": "17c5",
	"./2-charles.svg": "9576",
	"./3-great.jpg": "d664",
	"./4-housing.png": "8f18",
	"./5-kings.jpg": "235f",
	"./6-ocbc.jpg": "905d",
	"./7-ong.png": "7d48",
	"./8-osd.png": "88b4",
	"./9-osim.png": "b0e3",
	"./FT.png": "ceff",
	"./dsg-transparent-logo.png": "13a1",
	"./dsg-transparent-long-logo.png": "caaa",
	"./ftlogo.jpg": "303c",
	"./ge-logo.png": "20e5",
	"./julius-baer.png": "27f7",
	"./outer-edit.png": "f68b",
	"./rogers-and-sons.png": "3c3c",
	"./vcf_icm.png": "4bec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb34";